import getSellerAcceptedLanguages from './getSellerAcceptedLanguages';
import getSellerConfigurationQuery from './getSellerConfigurationQuery';
import { getVatRateBySellerIdQuery } from './getVatRateBySellerIdQuery';

export const SellerService = {
  getSellerConfigurationQuery,
  getSellerAcceptedLanguages,
  getVatRateBySellerIdQuery,
};
